import i18n from 'i18next'
import de from './de.json'

export default i18n.init({
  // we init with resources
  resources: {
    de: {
      translations: de,
    },
  },
  fallbackLng: 'de',
  debug: false,

  // have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
    prefix: '{',
    suffix: '}',
  },

  react: {
    wait: true,
  },
})
